<template>
  <div class="layout-container">
    <div class="iosPaddingBottom">
      <keep-alive >
        <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- <van-tabbar class="layout-tabbar" route >
      <van-tabbar-item
        v-for="navBar in tabBar"
        :key="navBar.to"
        :to="navBar.to"
        :icon="navBar.icon"
      >
        <template #icon="props">
          <img :src="props.active ? navBar.iconed : navBar.icon" />
        </template>
        <span class="text">{{ navBar.title }}</span>
      </van-tabbar-item>
    </van-tabbar> -->
    <!-- v-if="oneminute == 0" -->
    <van-tabbar class="layout-tabbar" route @change="changeTabbar">
      <van-tabbar-item :key="tabBar[0].to" :to="tabBar[0].to" :icon="tabBar[0].icon">
        <template #icon="props">
          <img :src="props.active ? tabBar[0].iconed : tabBar[0].icon" />
        </template>
        <span class="text">{{ tabBar[0].title }}</span>
      </van-tabbar-item>
      <van-tabbar-item :key="tabBar[1].to" :to="tabBar[1].to" :icon="tabBar[1].icon">
        <template #icon="props">
          <img :src="props.active ? tabBar[1].iconed : tabBar[1].icon" />
        </template>
        <span class="text">{{ tabBar[1].title }}</span>
      </van-tabbar-item>
      <div class="van-tabbar-item">
        <van-icon name="add" color="#1989fa" size="52" @click="toAdd" />
      </div>
      <van-tabbar-item :key="tabBar[2].to" :to="tabBar[2].to" :icon="tabBar[2].icon" :badge="count == 0?'':count">
        <template #icon="props">
          <img :src="props.active ? tabBar[2].iconed : tabBar[2].icon" />
        </template>
        <span class="text">{{ tabBar[2].title }}</span>
      </van-tabbar-item>
      <van-tabbar-item :key="tabBar[3].to" :to="tabBar[3].to" :icon="tabBar[3].icon">
        <template #icon="props">
          <img :src="props.active ? tabBar[3].iconed : tabBar[3].icon" />
        </template>
        <span class="text">{{ tabBar[3].title }}</span>
      </van-tabbar-item>
    </van-tabbar>
    <van-popup
      v-model="popupShow"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '100%' }"
      close-icon-position="bottom-left"
    >
    <div>
      <div class="popup_top_box">{{dateNow}}</div>
      <van-row type="flex" justify="space-around">
        <van-col span="5" v-for="val in routerList" :key="val.path" class="flex" @click="to(val)">
          <img :src="val.icon" class="img_icon" />
          <div class="icon_title">{{val.title}}</div>
        </van-col>
        <van-col span="5" class="flex" @click="toRecharge('recharge')" v-hasPermi="['channel:recharge:apply']">
          <img :src="'https://crmapi.data.tryine.com/profile/upload/2023/09/21/7fc6523c-e55b-49c9-83cf-0fdc5f80fa4c.png'" class="img_icon" />
          <div class="icon_title">充值申请</div>
        </van-col>
        <van-col span="5" class="flex" @click="toRecharge('transfer')" v-hasPermi="['channel:recharge:allo']">
          <img src="../../assets/images/desktop/transfer.png" class="img_icon" />
          <div class="icon_title">调拨</div>
        </van-col>
        <van-col span="5" class="flex" @click="toRecharge('refund')" v-hasPermi="['channel:recharge:refund']">
          <img src="../../assets/images/desktop/refund.png" class="img_icon" />
          <div class="icon_title">退款</div>
        </van-col>
        <van-col span="5"></van-col>
        <!-- <van-col span="5"></van-col>
        <van-col span="5"></van-col> -->
      </van-row>
    </div>
    </van-popup>
    <!-- /标签导航栏 -->
    <!-- 充值申请退款调拨 -->
    <recharge-refund-transfer ref="rechargeRefundTransfer"></recharge-refund-transfer>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import store from '@/store'
import { Tabbar, TabbarItem } from 'vant'
import { getNoGetIncomeCount } from '@/api/admi/user'
import RechargeRefundTransfer from '@/views/channel/recharge/RechargeRefundTransfer'

export default {
  name: 'LayoutIndex',
  data() {
    return {
      popupShow: false,
      dateNow: '',
      routerList: [
        {
          title: '新建客户',
          path: '/scrm/myCust/add',
          icon: 'https://apioa.fjyy.com.cn/profile/upload/2024/03/29/59b4b261-19ac-48b1-9312-700c73b3b368.png'
        },
        {
          title: '新建商机',
          path: '/scrm/custBo/add',
          icon: 'https://apioa.fjyy.com.cn/profile/upload/2024/03/29/c7f02a56-94e4-4deb-83da-e315f8660f65.png'
        },
        {
          title: '合同起草',
          path: '/cont/contract/add',
          icon: 'https://crmapi.data.tryine.com/profile/upload/2022/06/13/e6d9f683-be3c-4e03-8a05-fcd983293ee2.png'
        },
        {
          title: '添加垫款',
          path: '/cont/advances/addList',
          icon: 'https://crmapi.data.tryine.com/profile/upload/2022/09/30/1e41f403-ebcc-440a-a281-f4a206d89f5f.png'
        }
        // {
        //   title: '添加收款',
        //   path: '/cont/payment/addList',
        //   icon: 'https://testapi.oa.tryine.com/profile/upload/2022/07/16/792b1efb-76e6-47f7-8c16-3c633492e282.png'
        // },
        // {
        //   title: '添加收款',
        //   path: '/cont/payment/addPayment',
        //   icon: 'https://testapi.oa.tryine.com/profile/upload/2022/07/16/792b1efb-76e6-47f7-8c16-3c633492e282.png'
        // },
        // {
        //   title: '预充值',
        //   path: '/cont/payment/rechargeList',
        //   icon: 'https://crmapi.data.tryine.com/profile/upload/2023/07/08/0471f4a3-bf8d-421e-8b38-70f76f318ea2.png'
        // },
        // {
        //   title: '渠道预充值',
        //   path: '/channel/recharge/rechargeList',
        //   icon: 'https://crmapi.data.tryine.com/profile/upload/2023/07/08/0f1ec533-4aa1-4473-9f7a-6ef4c0d4c519.png'
        // },
        // {
        //   title: '垫款充值',
        //   path: '/cont/advances/queryList',
        //   icon: 'https://crmapi.data.tryine.com/profile/upload/2022/09/29/8ebdf717-fc24-4ff5-bcc1-f1c12cc39dfa.png'
        // }
      ]
    }
  },
  components: {
    RechargeRefundTransfer,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  computed: {
    ...mapGetters(['tabBar']),
    ...mapGetters(['count']),
    ...mapGetters(['oneminute']),
    key() {
      // return this.$key();
      return this.$route.path
    }
  },
  watch: {},
  async created() {
    await store.dispatch('user/GetInfo')
    await store.dispatch('user/GetDbCount')
  },
  async mounted() {
    // this['user/SET_ONEMINUTE'](0)
    const that = this
    await getNoGetIncomeCount().then(res => {
      if (res.data.incomeCount == 0 && res.data.needCount == 0) { that['user/SET_ONEMINUTE'](0) } else {
        if (that.oneminute > 0) {
          let minute = that.oneminute
          var time = setInterval(function() { --minute; that['user/SET_ONEMINUTE'](minute); if (minute == 0) { clearInterval(time) } }, 1000)
        }
      }
    })
  },
  methods: {
    ...mapMutations(['user/SET_ONEMINUTE']),
    toAdd() {
      this.popupShow = true
      this.dateNow = this.getDateNow()
    },
    getDateNow() {
      var date = new Date() // 获取当前日期
      var year = date.getFullYear() // 获取当前年份
      var month = date.getMonth() + 1 // 获取当前月份（记得+1）
      var dates = date.getDate() // 获取当前是几日
      var day = date.getDay() // 获取当前是星期几 周一返回1，周六返回6，周日返回0
      var arr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      return `${year}年${month}月${dates}日    ${arr[day]}`
    },
    to(route) {
      this.removeSession()
      if (route.sysType === 2) {
        // window.location.href = route.pathUrl
        window.open(route.path)
      } else {
        this.$router.push({
          path: route.path
        })
        this.popupShow = false
      }
    },
    toRecharge(type) {
      this.$refs.rechargeRefundTransfer.openVisible(type, 'layoutIndex')
    },
    removeSession() {
      sessionStorage.removeItem('rechargeSearch')
      sessionStorage.removeItem('paymentSearch')
      sessionStorage.removeItem('advancesSearch')
      sessionStorage.removeItem('contractSearch')
    },
    changeTabbar() {
      this.removeSession()
    }
  }
}
</script>

<style scoped lang="less">
.layout-container {
  .iosPaddingBottom{
    padding-bottom: env(safe-area-inset-bottom);
  }
  .layout-tabbar {
    i.icon {
      font-size: 40px;
    }
    span.text {
      font-size: 24px;
    }
  }
}
/deep/.van-tabbar{
  height: 120px;
  .van-tabbar-item{
    .van-tabbar-item__icon{
      img{
        width: 60px;
        height: 60px;
      }
    }
  }
  .add-btn{
    width: 80px;
  }
}
/deep/.van-popup{
  // background-color: #f5f7f9;
  .van-popup__close-icon--bottom-left{
    left: 325px;
    bottom: 5%;
  }
  .van-popup__close-icon{
    font-size: 100px;
  }
  .popup_top_box{
    width: 85%;
    background-color: #f5f7f9;
    margin: 40px auto 30px;
    padding: 60px 0;
    text-align: center;
    color: #333;
    font-size: 40px;
  }
  .flex{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .img_icon{
    width: 100px;
    height: 100px;
  }
  .icon_title{
    margin: 30px 0;
    font-weight: 400;
    color: #333;
    font-size: 24px;
  }
}

</style>
